import React from "react";
import Servicecard from "../../components/servicecard/Servicecard";
import { Serviceinfo } from "../../controller/Serviceinfo";
import styles from "./Services.module.css";
import banner from "../../assets/images/ServiceImage.png";
import SeoPage from "../../components/seo/SeoPage";

function Services() {
  return (
    <div>
      <SeoPage
        title="Our expertise areas are Consulting, Managed Services, Turnkey Projects"
        description="We also offer our expertise in staff augmentation, managed IT services, data analytics, and digital marketing to accelerate growth, efficiency for all sizes of businesses and industries"
      />{" "}
      <Servicecard
        data={Serviceinfo}
        heading="Our Areas of Expertise"
        subheading="We deliver end-to-end digital consulting, technology services, and talent solutions that help organizations modernize operations, establish a strong digital foundation, and accelerate sustainable growth.
Our flexible engagement model ensures measurable outcomes, scalability, and long-term value."
        image={banner}
        sliceEndNum={9} // Optional
      />
    </div>
  );
}

export default Services;
